export const BANNER_STYLE = {
    info: 0,
    warning: 1,
    error: 2
};
